import { AddShoppingCartOutlined } from "@mui/icons-material";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Rating,
  Typography,
} from "@mui/material";
import React from "react";
import "./ProductCard.css";

const ProductCard = ({ product, handleAddToCart }) => {


  return (
    <Card className="card">
      <CardMedia
        component="img"
        alt={product.name}
        aria-label= {`${product.rating} out of 5`}
        height="140"
        image={product.image}
      />
      <CardContent>
        <Typography gutterBottom>
        {product.name}
        </Typography>
        <Typography variant="h5" gutterBottom >
        ${product.cost}
        </Typography>
        <Rating value={product.rating}
        precision={0.5} readOnly>
        </Rating>
      </CardContent>
      <CardActions>
        <Button className="card-button" variant="contained" aria-label="add to cart" onClick={handleAddToCart}><AddShoppingCartOutlined/>ADD TO CART</Button>
      </CardActions>
    </Card>
  );
};

export default ProductCard;
